<template>
  <div>
    <HeadBar />
    <!--顶部bar-->
    <!--顶部logo、检索-->
    <HeadNav /><!-- 顶部导航-->
    <div class="lists">
      <div class="lists-inner">
        <CateSelect @typeClick="typeClick" />
        <div class="lists-bar">
          <SearchBarCircle
            :num="totalItem"
            v-model="searchKey"
            @btnClick="searchBarClick"
            placeholder="请输入关键字"
          />
        </div>
        <div class="lists-wrap">
          <div class="lists-user">
            <Expert
              v-for="(item, index) in lists"
              :key="index"
              :data="item"
              :eduMap="eduMap"
              class="lists-item"
            />
          </div>
        </div>
      </div>

      <!-- 分页-->
      <Pagination
        :total="totalItem"
        :page="page"
        @pageIndexChange="handlePageChange"
      />
    </div>

    <FootBar class="footer" />
  </div>
</template>
<script>
import { expertList } from "@/api/expert";
import CateSelect from "./components/CateSelect.vue";
import SearchBarCircle from "@/components/SearchBarCircle/index";
import Pagination from "@/components/Pagination/index";
import Expert from "@/components/Expert/index";
import { EDU_GRADE } from "@/constant/dict";
export default {
  components: {
    Pagination,
    SearchBarCircle,
    CateSelect,
    Expert,
  },
  data() {
    return {
      totalItem: 0,
      activeIndex: 0,
      searchKey: "",
      cates: [],
      lists: [],
      page: {
        pageIndex: 1,
        pageSize: 8,
      },
      eduMap: {},
      loading: false,
      currentCateId: null,
    };
  },
  created() {
    this.getDict();
  },
  methods: {
    async getDict() {
      const res = await this.$store.dispatch("getDictData", EDU_GRADE);
      const eduMap = {};
      res.forEach((item) => {
        eduMap[item.dictValue] = item.dictLabel;
      });
      this.eduMap = eduMap;
    },
    // 分页加载
    handlePageChange(index) {
      this.page.pageIndex = index;
      this.getList();
    },
    async getList() {
      this.listLoading = true;
      const params = {
        ...this.page,
        fieldCategoryId: this.currentCateId,
      };
      if (this.searchKey) {
        params.expertName = this.searchKey;
      }
      const { list, totalItem } = await this.$axios
        .post(expertList, params)
        .finally(() => {
          this.listLoading = false;
        });
      const result = list || [];
      result.forEach((item) => {
        const fields = [];
        item.fieldExes.forEach((field) => {
          fields.push(field.fieldCategoryName);
        });
        Object.assign(item, { fields });
      });
      this.lists = result;
      this.totalItem = totalItem;
    },
    cateClick(index) {
      this.activeIndex = index;
    },
    toDetail() {
      this.$router.push({ name: "expertsDetail" });
    },
    searchBarClick() {
      this.getList();
    },
    typeClick(params = {}) {
      const { firstTypeId, secondTypeId } = params;
      if (secondTypeId) this.currentCateId = secondTypeId;
      else this.currentCateId = firstTypeId;
      this.page.pageIndex = 1;
      this.totalItem = 0;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.lists {
  background: $home-bg;
  padding-bottom: 30px;
  &-inner {
    width: $max-width;
    margin: 0 auto;
    padding-top: 20px;
    margin-bottom: 20px;
  }
  &-bar {
    border-top: 1px solid #f3f3f3;
    background: white;
    padding: 15px 20px;
    margin-bottom: 20px;
  }
  &-wrap {
    min-height: 400px;
  }
  &-user {
    display: grid;
    grid-template-columns: repeat(4, calc(25% - 8px));
    gap: 10px;
  }
  &-item {
    background: white;
  }
}

.footer {
  padding-top: 0;
}
</style>
